import { render, staticRenderFns } from "./ShipAddressTypeForm.vue?vue&type=template&id=42c6505a"
import script from "./ShipAddressTypeForm.vue?vue&type=script&lang=js"
export * from "./ShipAddressTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports